// Components
import { Spinner } from '@/ui';
import ChangeOrderStatus from '../ChangeOrderStatus/ChangeOrderStatus';
import OrderDetails from '../OrderDetails/OrderDetails';
import { StyledButton, StyledContent } from './SettlementDetailsStyles';

// Models
import { IOrder, OrderStatus } from '@/models/order.model';
import { useTranslation } from 'react-i18next';

type TSettlementDetailsProps = {
  order: IOrder;
  isLoading?: boolean;
  canComplete?: boolean;
  onStatusChange?: (status: OrderStatus) => void;
  handleCompleteOrder?: () => void;
};

const SettlementDetails = ({
  order,
  isLoading,
  onStatusChange,
  handleCompleteOrder,
  canComplete,
}: TSettlementDetailsProps) => {
  const { t } = useTranslation('order');

  return (
    <Spinner spinning={isLoading}>
      <StyledContent>
        <OrderDetails order={order} />
        {canComplete && (
          <StyledButton type="primary" block shape="round" onClick={handleCompleteOrder}>
            {t('complete')}
          </StyledButton>
        )}
        <ChangeOrderStatus value={order.status} loading={isLoading} onChange={onStatusChange} />
      </StyledContent>
    </Spinner>
  );
};

export default SettlementDetails;
